import { render, staticRenderFns } from "./FuncionarioEditarGrupo.vue?vue&type=template&id=5d2fc350&"
import script from "./FuncionarioEditarGrupo.vue?vue&type=script&lang=js&"
export * from "./FuncionarioEditarGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports